/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFigmaIcon32Regular = forwardRef('LogoFigmaIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 12a4.992 4.992 0 0 0-2 4c0 1.636.785 3.088 2 4a5 5 0 1 0 8 4v-4a5 5 0 0 0 6-8 5 5 0 0 0-3-9h-8a5 5 0 0 0-3 9Zm8-7v6h3a3 3 0 1 0 0-6h-3Zm-2 8h-3a3 3 0 1 0 0 6h3v-6Zm-3-2h3V5h-3a3 3 0 1 0 0 6ZM9 24a3 3 0 0 1 3-3h3v3a3 3 0 1 1-6 0Zm11-5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" })));
});
